import React from "react";
import { connect } from "react-redux";
import { startGetFinance, startPaying } from "../actions/finance";
import { PlusOutlined } from '@ant-design/icons';
import { Button } from "antd";
import BillingTable from "./BillingTable";
import LoadingPage from "./LoadingPage";
import { separator } from "../utils/separator";
import PopUp from "./PopUp";
import ChargePopUp from "./ChargePopUp";
import "../styles/components/finance.scss";

class Finance extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isChargeShown: false,
      amount: undefined,
      planName: undefined,
      yearly: undefined,
      goal: undefined
    };
  }

  setUpState = () => {
    const params = new URLSearchParams(this.props.location.search);
    const goal = params.get("goal");
    const planName = params.get("plan_name");
    const amount = params.get("amount");
    const yearly = params.get("yearly");
    const isChargeShown = planName ? true : false;

    this.setState(() => ({
      amount,
      planName,
      goal,
      yearly,
      isChargeShown
    }));
  };

  componentDidMount() {
    if (!this.props.transaction) {
      this.props.startGetFinance();
    }
    this.setUpState();
  }

  openCharge = () => {
    this.setState(() => ({
      isChargeShown: true
    }));
  };

  closeCharge = () => {
    this.setState(() => ({
      isChargeShown: false
    }));
  };

  render() {
    return <>
      {this.props.transaction ? (
        <div className="container">
          <div className="container-wrapper">
            <h3>Your Credit</h3>
            <div className="credit-card">
              <h2>{`${separator(this.props.charged_budget)} Tomans`} </h2>
            </div>
            <h3>Transaction History</h3>
            <BillingTable data={this.props.transaction} />
            {this.state.isChargeShown && (
              <PopUp closePopUp={this.closeCharge}>
                <ChargePopUp
                  pay={this.props.startPaying}
                  amount={this.state.amount}
                  goal={this.state.goal}
                  planName={this.state.planName}
                  period={this.state.yearly ? "Yearly" : "Monthly"}
                />
              </PopUp>
            )}
          </div>
        </div>
      ) : (
        <LoadingPage />
      )}
    </>;
  }
}

const mapStateToProps = state => ({
  transaction: state.finance.transactions,
  charged_budget: state.auth.charged_budget
});

const mapDispatchToProps = dispatch => ({
  startGetFinance: () => dispatch(startGetFinance()),
  startPaying: (amount, goal, planName, period) =>
    dispatch(startPaying(amount, goal, planName, period))
});

export default connect(mapStateToProps, mapDispatchToProps)(Finance);
